export type { IAlbumType } from "./interfaces";
export { useGetAlbumTypes } from "./useGetAlbumTypes";
